
import './LoadingCircleSpinner.css'

const LoadingCircleSpinner = () =>{
    return(
        <div className="loader_overlay">       
            <div className='loader'>
            </div>     
        </div>
    )
}

export default LoadingCircleSpinner;